import { useEffect } from 'react';
import wsService from '../services/websocketService';
import useAuthStore from '../stores/authStore';
import useDeviceStore from '../stores/deviceStore';
import useAlarmStore from '../stores/alarmStore';
import useSystemStore from '../stores/systemStore';
import useBrineStore from '../stores/useBrineStore';
import type { ModbusSnapshot } from '../types/device';
import type { Alarm } from '../types/alarm';
import type { BrineSnapshot } from '../stores/useBrineStore';

export default function useWebSocket() {
  const token = useAuthStore((s) => s.token);

  useEffect(() => {
    if (!token) {
      // 登出時主動斷開 WebSocket
      wsService.disconnect();
      return;
    }

    // 連線狀態
    const onConnection = (data: { connected: boolean }) => {
      useSystemStore.getState().setWsConnected(data.connected);
    };

    // 設備更新
    const onDeviceUpdate = (data: ModbusSnapshot) => {
      useDeviceStore.getState().setModbusSnapshot(data);
      if (data.connected !== undefined) {
        useSystemStore.getState().setModbusConnected(data.connected);
      }
    };

    // 警報
    const onAlarm = (data: Alarm[]) => {
      if (Array.isArray(data)) {
        useAlarmStore.getState().addNewAlarms(data);
      }
    };

    // 心跳
    const onHeartbeat = (data: { modbus_connected?: boolean; mqtt_connected?: boolean }) => {
      if (data.modbus_connected !== undefined) {
        useSystemStore.getState().setModbusConnected(data.modbus_connected);
      }
      if (data.mqtt_connected !== undefined) {
        useSystemStore.getState().setMqttConnected(data.mqtt_connected);
      }
    };

    // 滷水/冷藏即時快照（馬修；後端 brine_ingest 推送）
    const onBrineUpdate = (data: BrineSnapshot) => {
      useBrineStore.getState().setSnapshot(data);
    };

    wsService.on('connection', onConnection);
    wsService.on('device_update', onDeviceUpdate);
    wsService.on('alarm', onAlarm);
    wsService.on('heartbeat', onHeartbeat);
    wsService.on('brine_update', onBrineUpdate);

    wsService.connect(token);

    return () => {
      wsService.off('connection', onConnection);
      wsService.off('device_update', onDeviceUpdate);
      wsService.off('alarm', onAlarm);
      wsService.off('heartbeat', onHeartbeat);
      wsService.off('brine_update', onBrineUpdate);
    };
  }, [token]);
}
